import React, { useEffect, useState } from 'react';
import { Input, List, Typography, Skeleton, Dropdown, Space, Menu, Button } from 'antd';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Loader from '../../shared/loader';
import NumberFormat from 'react-number-format';

const CoinsList = ({ fiatCoin, coinList, coinSearch, isLoading, selectedCoin, onReturnCoin,
    selectCoin, isPercent, isShowCoinBalance, CryptoCoin, cryptoCoin, isNetwork, isCrypto, fiatWalletCode,
    coinFields, selectionWalletcode, coinSelectionModal, selectedWithdrawCoin }) => {
    const [coinListData, setCoinListData] = useState(coinList);
    const [searchVal, setSearchVal] = useState([]);
    const [coinSelectedModal, setCoinSelectedModal] = useState(null);
    const { walletcode } = useParams();
    const menuBar = (item, selectedItem) => (
        <Menu>
            <ul className="dropdown-list">
                {item === "crypto" && <>

                    <Link to="/wallets"
                        className=' customicon c-pointer'><li className='c-pointer'>
                            Deposit
                        </li> </Link>
                    <Link to={`/wallets/${selectedItem?.walletCode}/withdraw`}
                        className='customicon c-pointer'>
                        <li className='c-pointer'>
                            Withdraw
                        </li></Link>
                </>}

            </ul>
        </Menu>
    )
    useEffect(() => {
        setCoinListData(coinList)
    }, [coinList])//eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (selectedCoin) {
            if (!onReturnCoin) {
                selectList(selectedCoin)
            }
        }
    }, [selectedCoin, selectedWithdrawCoin]);//eslint-disable-line react-hooks/exhaustive-deps
    const handleSearch = (value) => {
        let filtercoinsList;
        if (!value) {
            filtercoinsList = coinList;
        } else {
            filtercoinsList = coinList.filter(item => ((item[coinFields?.currencyCode])?.toLowerCase().includes(value.toLowerCase()) || 
            (item[coinFields?.currencyFullName])?.toLowerCase().includes(value.toLowerCase())));
        }
        setCoinListData(filtercoinsList)
    }
    

    const selectList = (item) => {
        if (selectCoin) { selectCoin(item) }
        else if (coinSelectionModal) {
            coinSelectionModal(item);
            setCoinSelectedModal(item?.walletCode || item?.coin || fiatCoin)
        }
    }

    const { Search } = Input;
    const { Text } = Typography
    return (

        <div className="coin-container">
            {coinSearch && <div className="coin-search dt-topspace">
                <Search value={searchVal} placeholder='Search Coin' suffix={<span className="icon md search c-pointer" />}
                    onChange={({ currentTarget }) => { setSearchVal(currentTarget.value); handleSearch(currentTarget.value) }} size="middle" bordered={false} className="coin-search-input " />
            </div>}
            {isLoading && <div className="db-kpi p-relative text-center" style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                <Loader />
            </div>}
            {!isLoading && <>
                <List
                    dataSource={coinListData}
                    renderItem={(item) => (
                        <List.Item key={item.id} className={`coin-item coin-flexgrow db-coinlist ${((item[coinFields?.currencyCode]?.toLowerCase()) === (coinSelectedModal?.toLowerCase() || fiatCoin?.toLowerCase() || CryptoCoin?.coin.toLowerCase() || cryptoCoin?.toLowerCase() || walletcode?.toLowerCase() || fiatWalletCode?.toLowerCase() || selectionWalletcode?.toLowerCase())) ? 'active' : ''}`} onClick={() => selectList(item)}
                            actions={
                                coinFields?.showTradebtn ? [
                                    <>
                                        {(item[coinFields?.currencyCode] === "USD" || item[coinFields?.currencyCode] === "EUR" || item[coinFields?.currencyCode] === "GBP" || item[coinFields?.currencyCode] === "CHF") ?
                                            <>
                                                <Dropdown
                                                    overlay={menuBar("fiat", item[coinFields?.currencyCode])}
                                                    trigger={['click']} placement="bottomCenter" arrow overlayClassName="secureDropdown depwith-drpdown" >
                                                    <Button onClick={e => e.preventDefault()}>
                                                        <Space>
                                                            <span class="icon md menubar"></span>

                                                        </Space>
                                                    </Button>
                                                </Dropdown>
                                            </> : <>
                                                <Dropdown
                                                    overlay={menuBar("crypto", item)}
                                                    trigger={['click']} placement="bottomCenter" arrow overlayClassName="secureDropdown depwith-drpdown" >
                                                    <Button onClick={e => e.preventDefault()}>
                                                        <Space>
                                                            <span class="icon md menubar"></span>

                                                        </Space>
                                                    </Button>
                                                </Dropdown>
                                            </>}
                                    </>
                                ] : ''
                            }
                        >
                            <Skeleton loading={isLoading} active avatar paragraph={{ rows: 1 }}>

                                <List.Item.Meta
                                    bordered
                                    actions={false}
                                    avatar={<div className=' '><span className={`crypto coin sm ${item[coinFields?.currencyCode]?.toLowerCase()}`} /></div>}
                                    title={<Text className={`coin-title ${item[coinFields?.currencyCode]?.toLowerCase()}`}>{item[coinFields?.currencyCode]}</Text>}
                                    description={<>{isCrypto && <div className='coin-fillname'>
                                        {item[coinFields?.currencyFullName]}<Text className={` fw-600 text-upper text-secondary d-block`}></Text>
                                    </div>}</>}
                                />
                                <div className={` ${isShowCoinBalance === true ? "d-nonecoinlist text-right" : "d-coinlist text-right"}`}>
                                    <NumberFormat displayType={'text'} className={`coin-val d-block coinval-width`}
                                        defaultValue={Math.abs(item[coinFields?.amount]) > 999999 ? Math.sign(item[coinFields?.amount]) * ((Math.abs(item[coinFields?.amount]) / 1000000).toFixed(1)) : Math.sign(item[coinFields?.amount]) * Math.abs(item[coinFields?.amount])} suffixText={Math.abs(item[coinFields?.amount]) > 999999 ? "M" : null} prefix={(item[coinFields?.currencyCode] === "USD" ? "$" : null) || (item[coinFields?.currencyCode] === "GBP" ? "£" : null) || (item[coinFields?.currencyCode] === "EUR" ? "€" : null)} thousandSeparator={true} />
                                    {isPercent && <>
                                        <Text className={`coin-price ${item.percent_change_1h < 0 ? 'text-red' : 'text-green'}`}>{item[coinFields?.percentage] ? item[coinFields?.percentage] : 0}%</Text></>}

                                </div>
                                <div className={` ${isNetwork === true}`}>
                                    <Text className={`coin-val d-block`}>{item[coinFields?.networkType]}</Text>
                                </div>
                            </Skeleton>
                        </List.Item>
                    )}
                />
            </>}

        </div>
    )
}

const connectStateToProps = ({ userConfig, oidc, WithdrawData }) => {
    return {
        userConfig: userConfig.userProfileInfo, user: oidc.user,
    }
}

export default connect(connectStateToProps)(CoinsList);